var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnlineTemp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19 19",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.9,12.8H2.2V3h14.7 M16.9,1.3H2.2C1.3,1.3,0.6,2.1,0.6,3v9.8c0,0.9,0.7,1.6,1.6,1.6h5.7v1.6H6.3v1.6h6.5v-1.6h-1.6 v-1.6h5.7c0.9,0,1.6-0.7,1.6-1.6V3C18.6,2.1,17.8,1.3,16.9,1.3"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.1,3.8L10.1,3.8v0.8c1.8,0.2,3,1.8,2.8,3.6c-0.2,1.5-1.3,2.6-2.8,2.8v0.8c2.2-0.2,3.8-2.2,3.6-4.4 C13.5,5.6,12,4,10.1,3.8 M9.3,3.9C8.5,3.9,7.8,4.2,7.1,4.7l0.6,0.6c0.5-0.4,1-0.6,1.6-0.7V3.9 M6.6,5.3C6.1,5.9,5.8,6.7,5.7,7.5 h0.8c0.1-0.6,0.3-1.1,0.7-1.6L6.6,5.3 M5.7,8.3c0.1,0.8,0.4,1.5,0.9,2.2l0.6-0.6c-0.4-0.5-0.6-1-0.7-1.6H5.7 M7.7,10.4L7.1,11 c0.6,0.5,1.4,0.8,2.2,0.9v-0.8C8.7,11,8.2,10.8,7.7,10.4 M9.9,5.9V8l1.8,1.1l-0.3,0.5L9.3,8.3V5.9H9.9z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineTemp);
export default __webpack_public_path__ + "static/media/online_temp.a534bf7f.svg";
export { ForwardRef as ReactComponent };